<div class="db-cdn-notice-section">
  <h4 class="db-cdn-notice-section__title">You must follow these steps for uninterrupted service of CDN</h4>
  <p class="db-cdn-notice-section__desc mt2 mb15">To make the SSL certificate renewal process automated follow this steps:</p>

<div class="db-cdn-notice-section__steps">
  <div *ngFor="let step of cdnSteps">
   <div class="db-step" [ngClass]="{'column': !!step.withTxt}">
     <div>{{step.id}}  <span class="ml3" [innerHTML]="step.desc"></span></div>
     <span *ngIf="!!step.withLabel" class="db-label ml8">REQUIRED</span>
     <ng-container [ngTemplateOutlet]="recordsSection" *ngIf="!!step.withTxt"></ng-container>
   </div>
  </div>
</div>
</div>

<ng-template #recordsSection>
  <div class="db-copy-info mt15">
    <div>
      <div class="db-copy-info__list-header">
          <p>{{ 'text_type' | dbText }}</p>
          <p>{{ 'text_name' | dbText }}</p>
          <p>{{ 'text_value' | dbText }}</p>
      </div>
      <div>
        <ul>
          <ng-container *ngFor="let record of records; let i = index" >
            <li class="db-copy-info__list-item {{record}}" *ngIf="record !== ''">
              <p>CNAME</p>
              <p>
                <input type="text" class="form-control host-name" #inputHostName [value]="record.name">
                <a [ngxClipboard]="inputHostName" (cbOnSuccess)="copiedHostName(i)" (click)="isCopiedHostNames[i] = true"
                   (onTooltipHide)="isCopiedHostNames[i] = false"
                   class="db-icon db-icon-ds-copy" dsTooltipSize="small" dsTooltipPosition="top"
                   dsTooltipColor="black"
                   [dsTooltip]="'<b>' + ((isCopiedHostNames[i] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
                </a>
              </p>
              <p>
                <input type="text" class="form-control" [(ngModel)]="record.value" #inputNameServer>
                <a [ngxClipboard]="inputNameServer" (cbOnSuccess)="copiedNameServer(i)" (click)="isCopiedCodes[i] = true"
                   (onTooltipHide)="isCopiedCodes[i] = false"
                   class="db-icon db-icon-ds-copy" dsTooltipSize="small" dsTooltipPosition="top"
                   dsTooltipColor="black"
                   [dsTooltip]="'<b>' + ((isCopiedCodes[i] ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
                </a>
              </p>
            </li>

          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</ng-template>
